module.exports = __webpack_public_path__ + "static/media/texture-wood-white.c9f03b45.jpg";